import React from 'react';
import clsx from 'clsx';

type Props = {
  theme: 'light' | 'dark';
};

type EstimationConfig = {
  duration: number;
  time: number;
  unit: 'seconds' | 'minute' | 'minutes';
};

const estimationItems: EstimationConfig[] = [
  {
    duration: 5,
    time: 30,
    unit: 'seconds',
  },
  {
    duration: 15,
    time: 1,
    unit: 'minute',
  },
  {
    duration: 30,
    time: 2,
    unit: 'minutes',
  },
];

type EstimationItemProps = Props & EstimationConfig;

function EstimationItem({ theme, duration, time, unit }: EstimationItemProps) {
  return (
    <div className={clsx('flex justify-between flex-col', {
      'text-gray-500': theme === 'light',
      'text-gray-200': theme === 'dark',
    })}
    >
      <span className={clsx('font-medium', {
        'text-gray-500': theme === 'light',
        'text-gray-300': theme === 'dark',
      })}
      >
        {`${duration} min audio`}
      </span>
      <span className={clsx('font-medium', {
        'text-gray-700': theme === 'light',
        'text-gray-300': theme === 'dark',
      })}
      >
        ~
        {time}
        {' '}
        {unit}
      </span>
    </div>
  );
}

export default function Estimation({ theme }: Props) {
  return (
    <div className="flex flex-col gap-0.5">
      <div className={clsx('rounded border p-2', {
        'bg-slate-50 border-gray-50': theme === 'light',
        'bg-gray-600 border-gray-600': theme === 'dark',
      })}
      >
        <div className={clsx('text-xs font-semibold mb-1.5', {
          'text-gray-700': theme === 'light',
          'text-gray-300': theme === 'dark',
        })}
        >
          Estimated note generation time
        </div>
        <div className="flex justify-between gap-0.5 text-xs">
          {estimationItems.map((item) => (
            <EstimationItem
              key={item.duration}
              theme={theme}
              {...item}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
